import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-omnibar',
    templateUrl: './omnibar.component.html',
    styleUrls: ['./omnibar.component.scss'],
    standalone: false
})
export class OmnibarComponent {
  @Input() disabled: boolean = false;
  @Input() value: string = '';
  @Input() placeholder: string = 'Filter...';
  @Output() keyup = new EventEmitter<KeyboardEvent>();
}
